<template>
    <div class="p-4">
        <img alt="fitt_light"
             class="absolute logo"
             src="@/assets/logos/fitt_light.png"
        >
        <row class="flex-col" style="margin-top: 80px;">
               <btn :ripple="false"
                    @click="showHideListItems('why_fitt')"
                    class="poppins-bold tracking-widest"
                    flat
               >Why Fitt?
                   <icon id="menu-icon" icon="menu-down" color="white" class="mb-1"></icon>
               </btn>
            <div class="overflow-hidden ml-8"
                 id="why_fitt"
                 style="max-height: 0; transition: all 0.4s; user-select: none;"
            >
                <tw-list-item @click="setDocumentScroll()"
                              class="mb-4">
                    <router-link v-slot="{ isActive, navigate }"
                                 class="poppins-bold cursor-pointer"
                                 to="/customizations"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Customizations</div>
                    </router-link>
                </tw-list-item>
                <tw-list-item @click="setDocumentScroll()"
                              class="mb-4">
                    <router-link v-slot="{ isActive, navigate }"
                                 class="poppins-bold cursor-pointer"
                                 to="/dispersing-notions"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Dispersing Notions</div>
                    </router-link>
                </tw-list-item>
                <tw-list-item
                    @click="setDocumentScroll()"
                    class="mb-4"
                >
                    <router-link v-slot="{ isActive, navigate }"
                                 class="poppins-bold cursor-pointer"
                                 to="/university-of-cambridge"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Cambridge</div>
                    </router-link>
                </tw-list-item>
                <tw-list-item
                    @click="setDocumentScroll()"
                    class="mb-4"
                >
                    <router-link v-slot="{ isActive, navigate }"
                                 to="/languages"
                                 class="poppins-bold cursor-pointer"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Languages</div>
                    </router-link>
                </tw-list-item>
                <tw-list-item
                    @click="setDocumentScroll()"
                    class="mb-4"
                >
                    <router-link v-slot="{ isActive, navigate }"
                                 to="/reporting"
                                 class="poppins-bold cursor-pointer"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Reporting</div>
                    </router-link>
                </tw-list-item>
                <tw-list-item
                    class="mb-4"
                    @click="setDocumentScroll()"
                >
                    <router-link v-slot="{ isActive, navigate }"
                                 to="/applications"
                                 class="poppins-bold cursor-pointer"
                    >
                        <div :class="isActive ? 'text-primary' : 'text-white'" @click="navigate">Applications</div>
                    </router-link>
                </tw-list-item>
            </div>
            <!--            <btn :ripple="false" class="tracking-widest poppins-bold" flat>-->
            <!--                Platform-->
            <!--            </btn>-->
            <!--            <btn :ripple="false" class="tracking-widest poppins-bold" flat>-->
            <!--                Pricing-->
            <!--            </btn>-->
            <btn :ripple="false"
                 class="tracking-widest poppins-bold"
                 flat
                 @click="$router.push('/case-studies'); setDocumentScroll()"
            >Case Studies
            </btn>
            <btn :ripple="false"
                 class="tracking-widest poppins-bold"
                 flat
                 @click="$router.push('/get-fitt'); setDocumentScroll()"
            >Get Fitt
            </btn>
<!--            <btn :ripple="false" @click="$navigate('https://manage.fitt.ai/')" class="tracking-widest poppins-bold"-->
<!--                 flat>-->
<!--                Log In-->
<!--            </btn>-->
            <btn :ripple="false" @click="$navigate('/ebook'); setDocumentScroll()" class="tracking-widest poppins-bold"
                 flat>
                EBOOK
            </btn>
            <btn :ripple="false" @click="$navigate('https://journey.fitt.ai/')" class="tracking-widest poppins-bold"
                 flat>
                Completing Fitt?
            </btn>
        </row>
        <!--            <divider class="mt-12 mb-6"></divider>-->
        <!--            <row>-->
        <!--                <div class="uppercase tracking-widest poppins-bold mb-5">Get the app</div>-->
        <!--                <column cols="full">-->
        <!--                    <row class="xs:flex-no-wrap" justify="start">-->
        <!--                        <column class="mr-4 mb-4" md="full" xs="1/2">-->
        <!--                            <btn block class="text-secondary poppins-bold md:w-64" color="white">-->
        <!--                                <icon class="mr-2 mb-1" icon="apple"></icon>-->
        <!--                                Apple store-->
        <!--                            </btn>-->
        <!--                        </column>-->
        <!--                        <column md="full" xs="1/2">-->
        <!--                            <btn block class="text-secondary poppins-bold md:w-64" color="white">-->
        <!--                                <icon class="mr-2" icon="google-play" size="lg"></icon>-->
        <!--                                Play store-->
        <!--                            </btn>-->
        <!--                        </column>-->
        <!--                    </row>-->
        <!--                </column>-->
        <!--                <divider class="my-8"></divider>-->
        <!--                <div class="text-gray-600">2020 fitt. All rights reserved</div>-->
        <!--            </row>-->
        <!--        </column>-->
    </div>
    <!--        </overlay>-->
    <!--        <btn @click="overlay = true" icon v-show="!overlay">-->
    <!--            <icon icon="text-short" color="white"></icon>-->
    <!--        </btn>-->
    <!--    </div>-->
</template>

<script>
    export default {
        name: "MobileMenu",
        components: {
            'tw-list-item': () => import('@/components/ListItem.vue'),
            'icon': () => import('@/components/display/Icon.vue'),
            // divider: () => import('../../components/Divider.vue'),
            btn: () => import('@/components/Btn.vue'),
            'row': () => import('@/components/display/Row.vue'),
            // 'column': () => import('../../components/display/Col.vue'),
            // 'icon': () => import('../../components/display/Icon.vue'),
            // overlay: () => import('../../components/Overlay.vue')
        },
        data: () => ({
            // overlay: false,
            // showLogo: false,
        }),
        methods: {
            showHideListItems(type) {
                if (type === 'why_fitt') {
                    let list = document.getElementById(type),
                        icon = document.getElementById('menu-icon');
                    icon.style.transition = '0.2s ease'
                    if (list.style.maxHeight === '0px') {
                        list.style.maxHeight = '175px';
                        icon.style.transform = 'rotate(180deg)';
                    } else {
                        list.style.maxHeight = '0px';
                        icon.style.transform = 'rotate(0deg)';
                    }
                }
            },
            setDocumentScroll() {
                document.documentElement.style.overflow = 'scroll';
                this.$emit('hide', false);
                this.showHideListItems('why_fitt');
            }
        },
        // watch: {
        //     overlay(val) {
        //         this.$emit('change', val);
        //         setTimeout(() => {
        //             this.showLogo = val;
        //         }, 100)
        //     }
        // }
    }
</script>

<style scoped>
    .logo {
        max-width: 130px;
        left: 95px;
        top: 45px;
    }
</style>
